<mat-card class="dialogWidth">
  <mat-card-header class="grow padding lrg bottom border bottom">
    <mat-card-title>Rename Key(s)</mat-card-title>
  </mat-card-header>
<mat-tab-group [(selectedIndex)]="initialTab">
  <mat-tab label="Single Key">
    <mat-card-content>
      <div [formGroup]="renameSingleForm">
        <div class="row">
          <mat-form-field class="grow margin lrg right" appearance="outline" floatLabel="always">
            <mat-label>Existing Key Name</mat-label>
            <input 
              matInput 
              formControlName="existingKeyName" 
              id="existingKeyName"
              class="uppercase"
              >
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field class="grow margin lrg right" appearance="outline" floatLabel="always">
            <mat-label>New Key Name</mat-label>
            <input 
              matInput 
              formControlName="newKeyName" 
              id="newKeyName"
              class="uppercase"
              >
          </mat-form-field>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button mat-stroked-button class="margin lrg right" color="primary" (click)="close()">Cancel</button>
      <button mat-raised-button class="margin lrg right" color="primary" [disabled]="!renameSingleForm.valid" (click)="checkSingleKeyCombination()">Rename</button>
    </mat-card-actions>
  </mat-tab>
  <mat-tab label="Multiple Keys" *ngIf="showMultipleKeysOption">
    <mat-card-content>
      <div [formGroup]="renameForm">
        <div class="row padding lrg top">
          <p>Existing Values</p>
        </div>
        <div class="row">
          <mat-form-field class="grow margin lrg right" appearance="outline" floatLabel="always">
            <mat-label>Prefix</mat-label>
            <input 
              matInput 
              formControlName="existingPrefix" 
              id="prefix"
              class="uppercase"
              >
          </mat-form-field>
          <mat-form-field class="grow margin lrg right" appearance="outline" floatLabel="always">
            <mat-label>From</mat-label>
            <input 
              matInput 
              formControlName="existingFrom" 
              id="from"
              class="uppercase"
              >
          </mat-form-field>
          <mat-form-field class="grow margin lrg right" appearance="outline" floatLabel="always">
            <mat-label>To</mat-label>
            <input 
              matInput 
              formControlName="existingTo" 
              id="to"
              class="uppercase"
              >
          </mat-form-field>
          <mat-form-field class="grow margin lrg right" appearance="outline" floatLabel="always">
            <mat-label>Suffix</mat-label>
            <input 
              matInput 
              formControlName="existingSuffix" 
              id="suffix"
              class="uppercase"
              >
          </mat-form-field>
        </div>
        <div class="row">
          <p>New Values</p>
        </div>
        <div class="row">
          <mat-form-field class="grow margin lrg right" appearance="outline" floatLabel="always">
            <mat-label>Prefix</mat-label>
            <input 
              matInput 
              formControlName="newPrefix" 
              id="prefix"
              class="uppercase"
              >
          </mat-form-field>
          <mat-form-field class="grow margin lrg right" appearance="outline" floatLabel="always">
            <mat-label>From</mat-label>
            <input 
              matInput 
              formControlName="newFrom" 
              id="from"
              class="uppercase"
              >
          </mat-form-field>
          <mat-form-field class="grow margin lrg right" appearance="outline" floatLabel="always">
            <mat-label>To</mat-label>
            <input 
              matInput 
              formControlName="newTo" 
              id="to"
              class="uppercase"
              >
          </mat-form-field>
          <mat-form-field class="grow margin lrg right" appearance="outline" floatLabel="always">
            <mat-label>Suffix</mat-label>
            <input 
              matInput 
              formControlName="newSuffix" 
              id="suffix"
              class="uppercase"
              >
          </mat-form-field>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button mat-stroked-button class="margin lrg right" color="primary" (click)="close()">Cancel</button>
      <button mat-raised-button class="margin lrg right" color="primary" [disabled]="!renameForm.valid" (click)="checkAssignedKeyCombinations()">Rename</button>
    </mat-card-actions>
  </mat-tab>
</mat-tab-group>
</mat-card>